export default defineNuxtPlugin(() => {
  const profileStore = useProfileStore();
  const route = useRoute();

  const sendHotjarAttributes = () => {
    // Check if Hotjar is available
    if (typeof window === 'undefined' || typeof window.hj !== 'function') {
      return;
    }

    // Get user data
    const userId = profileStore.profile?.id || null;
    const affiliateTag = useCookie('affiliateTag').value || null;
    
    // Format signed_up date from createdAt
    let signedUp = null;
    if (profileStore.profile?.createdAt) {
      const date = new Date(profileStore.profile.createdAt);
      signedUp = date.toISOString().split('T')[0] + 'Z';
    }



    // Only send if we have valid user data
    if (!userId) {
      return;
    }

    try {
      // Send user attributes to Hotjar
      window.hj('identify', userId, {
        'user_id': userId,
        'affiliate_id': affiliateTag,
        'signed_up': signedUp,
      });
    } catch (error) {
      console.error('Error sending Hotjar attributes:', error);
    }
  };

  // Wait for Hotjar to be ready
  const waitForHotjar = () => {
    return new Promise<void>((resolve) => {
      const checkHotjar = () => {
        if (typeof window !== 'undefined' && typeof window.hj === 'function') {
          resolve();
        } else {
          setTimeout(checkHotjar, 100);
        }
      };
      checkHotjar();
    });
  };

  // Send attributes when user logs in or profile changes
  const unwatchProfile = watch(
    () => profileStore.profile,
    async () => {
      if (profileStore.isLoggedIn) {
        // Wait for Hotjar to be ready
        await waitForHotjar();
        // Small delay to ensure everything is loaded
        setTimeout(sendHotjarAttributes, 2000);
      }
    },
    { immediate: true }
  );

  // Send attributes on route change (for already logged in users)
  watch(
    () => route.path,
    async () => {
      if (profileStore.isLoggedIn) {
        await waitForHotjar();
        setTimeout(sendHotjarAttributes, 1000);
      }
    }
  );

  // Cleanup on unmount
  onUnmounted(() => {
    unwatchProfile();
  });
}); 